import React, { useContext, useState, useEffect } from 'react';
import useMount from 'ggApp/shared/hooks/useMount';
import { PureTranslator } from 'ggApp/modules/translator/components';
import { CHECKOUT_STEP_NAMES as STEP_NAMES } from 'ggApp/modules/newCheckout/constants';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import { AddressList } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/AddressList';
import { AddressComponent } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/AddressComponent';
import { updateOrderStepState } from 'ggApp/shared/context/Order/services/tracking';

import { Home, Title, SubTitle } from './styles';

export const HomeAddress = ({ send, stepData }) => {
    const { current, orderNumber, orderMode } = useContext(OrderContext);
    const [addressInForm, setAddressInForm] = useState(null);
    const [shouldShowList, setShouldShowList] = useState(true);

    useEffect(() => {
        if (current.matches('homeAddress')) {
            setShouldShowList(!current.matches('homeAddress.form'));
        }
    }, [current]);

    useMount(() => {
        if (current.matches('homeAddress')) {
            updateOrderStepState({
                orderMode,
                orderNumber,
                currentStep: STEP_NAMES.HOME_ADDRESS,
            });
        }
    });

    return (
        <Home data-testid="home-address">
            <Title>
                <PureTranslator tk={stepData.title} />
            </Title>

            <SubTitle>
                <PureTranslator tk={stepData.subTitle} />
            </SubTitle>

            {shouldShowList ? (
                <AddressList
                    stepName={STEP_NAMES.HOME_ADDRESS}
                    addTK={stepData.addBtn}
                    setAddressInForm={setAddressInForm}
                    current={current}
                    send={send}
                />
            ) : (
                <AddressComponent
                    address={addressInForm}
                    stepData={stepData}
                    shouldShowBackBtn
                    current={current}
                    send={send}
                />
            )}
        </Home>
    );
};
